import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { RemoveSeparationButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { createSeparationCountSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../../../Layout';
import SeparationDetailsSection from './SeparationDetailsSection';
import SeparationDryMassesSection from './SeparationDryMassesSection';
import SeparationWetMassesSection from './SeparationWetMassesSection';

let SeparationPageSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const index = namePrefix?.match(/\.Separation\./g)?.length ?? 0;

  const separationCount = useSelector(createSeparationCountSelector(createWorksheetSelector!));

  const isDryBeforeSeparation = useSelector(
    pipe(
      createWorksheetSelector!(`Masses.StateAfterMassDetermination`),
      (s: StateOfMaterial) => s === StateOfMaterial.OvenDry
    )
  );

  const separationNumberSuffix = separationCount > 1 ? ` ${index + 1}` : '';

  return (
    <PageSection heading={`Separation${separationNumberSuffix}`}>
      <SeparationDetailsSection />

      <NamePrefixModifier appendNamePrefix="Separation">
        {isDryBeforeSeparation ? (
          <SeparationDryMassesSection heading={`Portion${separationNumberSuffix} Masses`} />
        ) : (
          <SeparationWetMassesSection heading={`Portion${separationNumberSuffix} Masses`} />
        )}
      </NamePrefixModifier>

      {index === 0 && !isDryBeforeSeparation && (
        <ListFieldSection>
          <Field input={<TextOutput />} label="Specimen Total Wet Mass" name="Masses.WetMass" />
        </ListFieldSection>
      )}
      {index === 0 && isDryBeforeSeparation && (
        <ListFieldSection>
          <Field input={<TextOutput />} label="Specimen Total Dry Mass" name="Masses.DryMass" />
        </ListFieldSection>
      )}
      <NamePrefixModifier appendNamePrefix="Separation">
        <div>
          <RemoveSeparationButton />
        </div>
      </NamePrefixModifier>
    </PageSection>
  );
};

SeparationPageSection = withInjectedProps(SeparationPageSection);

export { SeparationPageSection };
export default SeparationPageSection;
